import {combineReducers} from "redux";
import loading from "./loading";
import authReducer from "./authReducer";
import questionnaireReducer from "./questionnaireReducer";
import dataReducer from "./dataReducer";
import profileReducer from "./profileReducer";
import tutorAuthReducer from "./tutorAuthReducer";
const rootReducer = combineReducers({
  loading,
  authReducer,
  dataReducer,
  questionnaireReducer,
  profileReducer,
  tutorAuthReducer,
});

export default rootReducer;
